// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:40
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class AvailableMember_abstract extends BaseObject {
  static $t: string = 'SagaBase.AvailableMember';
  $t: string = 'SagaBase.AvailableMember';

  public static GetMembers(): string[] {
    return ['Selected', 'Description', 'AvailableFrom', 'Vehicle'];
  }

  public GetMembers(): string[] {
    return AvailableMember_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.AvailableFrom = this.AvailableFrom && new Date(this.AvailableFrom);

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Selected: boolean = false;
  public Description: string;
  public AvailableFrom: Date = new Date();
  public Vehicle: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
